import React, { useEffect, useState } from "react";
import { styled } from "@material-ui/styles";
import { injectIntl } from "react-intl";
import { RouteComponentProps } from "@reach/router";
import messages from "./PagePeople.intl";
import Players from "../players";
import Teams from "../teams";
import { Theme, Paper } from "@material-ui/core";
// import Matches from "../matches-tab";
import queryString from "query-string";
import SnackBar from "../snackbar";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import { IStyledArguments } from "../../types/styled-arguments";

const StyledPaper = styled(Paper)<Theme>(({ theme }) => ({
  boxSizing: "border-box",
  marginBottom: theme.spacing(5),
  // textAlign: "center",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: 830,
  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    boxShadow: "none",
  },
}));

const TabContainer = styled("div")<Theme>(({ theme }) => ({
  backgroundColor: theme.palette.extra.default,
}));

enum TabNames {
  players = "players",
  teams = "teams",
}
const PATH_TO_TAB: { [path: string]: string } = {
  "/people/players": TabNames.players,
  "/people/teams": TabNames.teams,
};
const TAB_TO_PATH: { [tabName: string]: string } = {
  [TabNames.players]: "/people/players",
  [TabNames.teams]: "/people/teams",
};

const ToggleWrapper = styled("div")(({ theme }: IStyledArguments) => ({
  padding: theme.spacing(2, 2, 1.5),
  background: "#fff",
}));

const Toggle = styled("div")(({ theme }: IStyledArguments) => ({
  display: "flex",
  background: theme.palette.extra.backgroundGrey,
  border: `1px solid ${theme.palette.extra.borderColor}`,
  borderRadius: 12,
  padding: 3,
  maxWidth: 320,
  margin: "0 auto",
}));

const ToggleOption = styled("button")<{ $active?: boolean }>(
  ({ theme, $active }: IStyledArguments & { $active?: boolean }) => ({
    flex: 1,
    textAlign: "center",
    padding: theme.spacing(1.1, 0),
    borderRadius: 9,
    border: "none",
    cursor: "pointer",
    appearance: "none",
    fontFamily: theme.typography.alternateFontFamily,
    fontWeight: $active ? 600 : 500,
    fontSize: "0.85rem",
    background: $active ? "#ffffff" : "transparent",
    color: $active ? theme.palette.primary.dark : theme.palette.text.secondary,
    boxShadow: $active ? "0 1px 3px rgba(16, 21, 26, 0.08)" : "none",
    transition: "all 0.15s ease",
  })
);

type PagePeopleProps = Required<
  Pick<RouteComponentProps, "navigate" | "path" | "location">
>;

const PagePeople = injectIntl<PagePeopleProps>(
  ({ intl, navigate, path, location }) => {
    const currentTab = PATH_TO_TAB[path] || TabNames.players;

    let params = queryString.parse(location.search);
    let userDeleted = params["userDeleted"];
    console.log("user-deleted-----", userDeleted);
    const [openSnackbar, setOpenSnackbar] = useState<boolean>(
      Boolean(userDeleted)
    );

    const handleChange = (tab: TabNames) => {
      navigate(TAB_TO_PATH[tab], {
        replace: true,
      });
    };

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [currentTab]);

    return (
      <StyledPaper>
        <ToggleWrapper>
          <Toggle>
            <ToggleOption
              type="button"
              data-testid="players-tab"
              $active={currentTab === TabNames.players}
              onClick={() => handleChange(TabNames.players)}
            >
              {intl.formatMessage(messages.players)}
            </ToggleOption>
            <ToggleOption
              type="button"
              data-testid="teams-tab"
              $active={currentTab === TabNames.teams}
              onClick={() => handleChange(TabNames.teams)}
            >
              {intl.formatMessage(messages.teams)}
            </ToggleOption>
          </Toggle>
        </ToggleWrapper>
        <TabContainer>
          {currentTab === TabNames.players && (
            <Players refetchPlayers={Boolean(userDeleted)} />
          )}
          {currentTab === TabNames.teams && <Teams />}
        </TabContainer>
        <SnackBar
          data-testid="delete-error"
          open={openSnackbar}
          message="user has been deleted"
          variant="success"
          action={() => {
            setOpenSnackbar(false);
          }}
          actionText={<CancelIcon />}
        />
      </StyledPaper>
    );
  }
);

export default PagePeople;
